import { render, staticRenderFns } from "./plano_editor.vue?vue&type=template&id=02177159&"
import script from "./plano_editor.vue?vue&type=script&lang=js&"
export * from "./plano_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02177159')) {
      api.createRecord('02177159', component.options)
    } else {
      api.reload('02177159', component.options)
    }
    module.hot.accept("./plano_editor.vue?vue&type=template&id=02177159&", function () {
      api.rerender('02177159', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/plano_editor.vue"
export default component.exports